<template>
  <div>
    <div class="vx-card p-6" style="height: 85vh;">
      <div class="flex flex-wrap" style="font-size: 40px; justify-content: center;">
        <label style="margin-top: 12px !important;">OBDTALK VERİ İŞLEM</label>
      </div>

      <div style="width: 100%;">
        <div class="vx-row mt-5">
          <div class="vx-col md:w-1/5 w-full">
            <label class="text-sm"><b>Obd Talk Param Id </b></label>
            <vs-input type="number" class="w-full" placeholder="ObdTalk index" v-model="obdTalkParam.obdTalkParamId" />
          </div>
          <div class="vx-col md:w-1/5 w-full">
            <label class="text-sm"><b>Mask Value </b></label>

            <vs-input type="number" class="w-full" placeholder="Mask Value" v-model="obdTalkParam.maskValue" />
          </div>

          <div class="vx-col md:w-1/5 w-full mt-3">
            <vs-button type="filled" class="mr-2" @click="getObdTalkParam()">Getir</vs-button>
          </div>
        </div>

        <div class="vx-row mt-5">
          <div class="vx-col md:w-1/3 w-full">
            <label class="text-sm"><b>Ecu Action Name</b></label>
            <vs-input type="text" placeholder="Obd Talk Param Açıklama" class="w-full" v-model="obdTalkParam.ecuActionName" />
          </div>

          <div class="vx-col md:w-1/3 w-full">
            <label class="text-sm"><b>Ecu Action Amount</b></label>
            <vs-input type="number" placeholder="EcuActionAmount" class="w-full" v-model="obdTalkParam.ecuActionAmount" />
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <label class="text-sm"><b>Action Rule Type</b></label>
            <vs-input type="text" placeholder="ActionRuleType" class="w-full" v-model="obdTalkParam.actionRuleType" />
          </div>
        </div>

        <div class="vx-row" style="margin-top: 15px;">
          <div class="vx-col md:w-1/3 w-full">
            <div class="vx-row">
              <div class="vx-col md:w-1/3 w-full">
                <label class="text-sm"><b>EcuActionIsRisk</b></label>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/4">
                  <label class="text-sm"><b>Yes</b></label>
                </div>
                <div class="vx-col md:w-1/4">
                  <input class="vs-radio mr-1" type="radio" v-model="obdTalkParam.ecuActionIsRisk" value="true" />
                </div>
                <div class="vx-col md:w-1/4">
                  <label class="text-sm"><b>No</b></label>
                </div>
                <div class="vx-col md:w-1/4">
                  <input class="vs-radio" type="radio" v-model="obdTalkParam.ecuActionIsRisk" value="false" />
                </div>
              </div>
            </div>
            <div class="vx-row mt-2">
              <div class="vx-col md:w-1/3 w-full">
                <label class="text-sm"><b>EcuActionIsReal</b></label>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/4">
                  <label class="text-sm"><b>Yes</b></label>
                </div>
                <div class="vx-col md:w-1/4">
                  <input class="vs-radio mr-1" type="radio" v-model="obdTalkParam.ecuActionIsReal" value="true" />
                </div>
                <div class="vx-col md:w-1/4">
                  <label class="text-sm"><b>No</b></label>
                </div>
                <div class="vx-col md:w-1/4">
                  <input class="vs-radio" type="radio" v-model="obdTalkParam.ecuActionIsReal" value="false" />
                </div>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <label class="text-sm"><b>ActionDLC</b></label>
            <vs-input type="number" placeholder="ActionDLC" class="w-full" v-model="obdTalkParam.actionDLC" />
          </div>

          <div class="vx-col md:w-1/3 w-full">
            <label class="text-sm"><b>ActionData</b></label>
            <vs-input type="text" placeholder="ActionData" class="w-full" v-model="obdTalkParam.actionData" />
          </div>

          <div class="vx-col md:w-1/3 w-full" style="margin-top: 4px;">
            <label class="text-sm"><b>ActionOrder</b></label>
            <vs-input type="number" class="w-full" placeholder="ActionOrder" v-model="obdTalkParam.actionOrder" />
          </div>

          <div class="vx-col md:w-1/3 w-full" style="margin-top: 4px;">
            <label class="text-sm"><b>PIdHex</b></label>
            <vs-input class="w-full" type="text" placeholder="PIdHex" v-model="obdTalkParam.pIdHex" />
          </div>

          <div class="vx-col md:w-1/3 w-full mt-5">
            <vs-button type="filled" class="mr-2" @click="saveObdTalkParam()">ObdTalkParam Ekle / Güncelle</vs-button>
          </div>
        </div>

        <div class="vx-row" style="margin-top: 30px; margin-bottom: 15px;">
          <div class="vx-col md:w-1/6 w-full">
            <label class="text-sm"><b>İndex Başlangıç</b></label>
            <vs-input class="w-full" type="number" placeholder="İndex Başlangıç" @input="calculateMask()" v-model="obdTalkParam.startIndex" />
          </div>
          <div class="vx-col md:w-1/6 w-full">
            <label class="text-sm"><b>İndex Bitiş</b></label>
            <vs-input class="w-full" type="number" placeholder="İndex Bitiş" @input="calculateMask()" v-model="obdTalkParam.finishIndex" />
          </div>
          <div class="vx-col md:w-1/6 w-full">
            <label class="text-sm"><b>Action Value</b></label>
            <vs-input class="w-full" type="text" placeholder="Action Value" v-model="obdTalkParam.actionValue" />
          </div>
          <div class="vx-col md:w-1/6 w-full">
            <label class="text-sm"><b>Action Description</b></label>
            <vs-input class="w-full" type="text" placeholder="Action Description" v-model="obdTalkParam.actionDescription" />
          </div>
          <div class="vx-col md:w-1/6 w-full mt-3">
            <vs-button type="filled" @click="saveObdTalkMask()">Mask Ekle</vs-button>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/9" style="margin-bottom: 50px;">
          <!-- Byteları oluşturan  -->
          <div class="vx-col">
            <!-- Byteları oluşturan  -->
            <div class="vx-col">
              <div class="vx-row">
                A
              </div>
              <div v-for="(trSerial, j) in 8" :key="j" class="vx-row">
                <div class="vx-col" style="width: 33px; text-align: right;">
                  <label style=""
                    ><b> {{ j }} </b></label
                  >
                </div>
                <div class="vx-col">
                  <vs-checkbox @click="SetStartStopIndex(j, $event)">{{ j }}</vs-checkbox>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <!-- Byteları oluşturan  -->
              <div class="vx-col">
                <div class="vx-row">
                  B
                </div>
                <div v-for="(trSerial, j) in 8" :key="j" class="vx-row">
                  <div class="vx-col" style="width: 33px; text-align: right;">
                    <label style=""
                      ><b> {{ j }} </b></label
                    >
                  </div>
                  <div class="vx-col">
                    <vs-checkbox @click="SetStartStopIndex(j + 8, $event)">{{ j + 8 }}</vs-checkbox>
                  </div>
                </div>
              </div>
              <!-- json param result oluşturan -->
              <div class="vx-col"></div>
              <!-- add butonu -->
              <div class="vx-col"></div>
              <!-- genel JSON text -->
              <div class="vx-col"></div>
            </div>
            <div class="vx-row">
              <!-- Byteları oluşturan  -->
              <div class="vx-col">
                <div class="vx-row">
                  C
                </div>
                <div v-for="(trSerial, j) in 8" :key="j" class="vx-row">
                  <div class="vx-col" style="width: 33px; text-align: right;">
                    <label style=""
                      ><b> {{ j }} </b></label
                    >
                  </div>
                  <div class="vx-col">
                    <vs-checkbox @click="SetStartStopIndex(j + 16, $event)">{{ j + 16 }}</vs-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <!-- Byteları oluşturan  -->
              <div class="vx-col">
                <div class="vx-row">
                  D
                </div>
                <div v-for="(trSerial, j) in 8" :key="j" class="vx-row">
                  <div class="vx-col" style="width: 33px; text-align: right;">
                    <label style=""
                      ><b> {{ j }} </b></label
                    >
                  </div>
                  <div class="vx-col">
                    <vs-checkbox @click="SetStartStopIndex(j + 24, $event)">{{ j + 24 }}</vs-checkbox>
                  </div>
                </div>
              </div>
              <!-- json param result oluşturan -->
              <div class="vx-col"></div>
              <!-- add butonu -->
              <div class="vx-col"></div>
              <!-- genel JSON text -->
              <div class="vx-col"></div>
            </div>
          </div>
        </div>

        <div class="vx-col md:w-1/2">
          <vs-table :maxItems="17" :pagination="true" :data="obdTalkParamList">
            <template slot="thead">
              <vs-th width="5%">ElementId</vs-th>
              <vs-th width="30%">ActionValue</vs-th>

              <vs-th width="30%">ActionDescription</vs-th>
              <vs-th width="15%">MaskValue</vs-th>
              <vs-th width="15%">MaskActionType</vs-th>
              <vs-th width="2%">Sil</vs-th>
              <vs-th width="3%">Güncelle</vs-th>
              <vs-th width="5%">MaskTypeGüncelle</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="tr.obdTalkMaskElementId" v-for="(tr, i) in data" class="pt-0 pb-1">
                <template v-if="tr.obdTalkMaskElementId">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ tr.obdTalkMaskElementId }}</b>
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <vs-input type="text" style="width: -webkit-fill-available;" placeholder="ObdTalk index" v-model="tr.actionValue" />
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <vs-input type="text" style="width: -webkit-fill-available;" placeholder="ObdTalk index" v-model="tr.actionDescription" />
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <vs-input type="text" readonly style="width: -webkit-fill-available;" placeholder="ObdTalk index" v-model="tr.maskValue" />
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <vs-input type="text" style="width: -webkit-fill-available;" placeholder="ObdTalk index" v-model="tr.maskActionType" />
                  </vs-td>
                  <td>
                    <a href="" @click.prevent="deleteObdTalkMaskElement(tr)" style="color: red; font-size: 10px;"><b>Sil</b></a>
                  </td>
                  <td>
                    <a href="" @click.prevent="updateObdTalkMaskElement(tr)" style="color: orange; font-size: 10px;"><b>Güncelle</b></a>
                  </td>

                  <td>
                    <a href="" @click.prevent="updateObdTalkMask(tr)" style="color:  #7393B3 ; font-size: 10px;"><b>ActionTypeGüncelle</b></a>
                  </td>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

// Cell Renderer

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      obdTalkParamList: [{ startIndex: null, finishIndex: null, maskValue: null, ecuActionName: null, obdTalkMaskElementId: null, obdTalkParamId: null, actionValue: null, actionDescription: null }],
      obdTalkParam: { startIndex: null, finishIndex: null, maskValue: null, ecuActionName: null, obdTalkMaskElementId: null, obdTalkParamId: null, actionValue: null, actionDescription: null },

      bitList: [{ byte: "A0" }, { byte: "A1" }, { byte: "A2" }, { byte: "A3" }, { byte: "A4" }, { byte: "A5" }, { byte: "A6" }, { byte: "A7" }],
      byteList: [
        { byteName: "A", bitOffset: "0-7" },
        { byteName: "B", bitOffset: "8-15" },
        { byteName: "C", bitOffset: "16-23" },
        { byteName: "D", bitOffset: "24-31" },
      ],
    };
  },

  computed: {},
  methods: {
    getObdTalkParam: async function() {
      this.$vs.loading();
      this.obdTalkParamList = await repository.postEntity("ResearchAndDevelopment/GetObdTalk", this.obdTalkParam).then((r) => r.list);
      this.obdTalkParam = Object.assign({}, this.obdTalkParamList[0]);
      //this.obdTalkParam = JSON.parse(JSON.stringify(this.obdTalkParamList[0]));
      console.log(this.obdTalkParam);
      this.$vs.loading.close();
    },

    SetStartStopIndex: async function(j, e) {
      if (e.target.checked) {
        if (this.obdTalkParam.startIndex == null) {
          this.obdTalkParam.startIndex = j;
        } else {
          if (this.obdTalkParam.startIndex > j) {
            this.obdTalkParam.finishIndex = this.obdTalkParam.startIndex;
            this.obdTalkParam.startIndex = j;
          } else {
            this.obdTalkParam.finishIndex = j;
          }
        }

        this.calculateMask();
      }
    },

    saveObdTalkMask: async function() {
      // if (this.obdTalkParam.obdTalkParamId == null) {
      //   let resultConfirm = await this.$swal.fire({
      //     icon: "warning",
      //     title: "Devam etmek istediğinize emin misiniz?",
      //     text: "ObdTalkParamId girmediğiniz için. ObdTalkParam Tablosuna Yeni kayıt atılarak devam edilecektir.",
      //     showCancelButton: true,
      //     confirmButtonColor: "#3085d6",
      //     cancelButtonColor: "#d33",
      //     confirmButtonText: "Evet",
      //     cancelButtonText: "Hayır",
      //   });

      //   if (resultConfirm.isConfirmed) null;
      //   else return;
      // }

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        //text: "",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("ResearchAndDevelopment/SaveObdTalkMaskAndElement", this.obdTalkParam);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "Kaydetme Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      this.obdTalkParam = { startIndex: null, finishIndex: null, maskValue: this.obdTalkParam.maskValue, ecuActionName: null, obdTalkMaskElementId: null, obdTalkParamId: this.obdTalkParam.obdTalkParamId, actionValue: null, actionDescription: null };
      this.getObdTalkParam();
    },

    saveObdTalkParam: async function() {
      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        //text: "",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      let result = null;
      if (this.obdTalkParam.obdTalkParamId == null) {
        result = await repository.postEntity("ResearchAndDevelopment/saveObdTalkParam", this.obdTalkParam);
        this.obdTalkParam.obdTalkParamId = result.returnID;
      } else result = await repository.postEntity("ResearchAndDevelopment/updateObdTalkParam", this.obdTalkParam);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "Kaydetme Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      this.obdTalkParam = { startIndex: null, finishIndex: null, maskValue: null, ecuActionName: null, obdTalkMaskElementId: null, obdTalkParamId: this.obdTalkParam.obdTalkParamId, actionValue: null, actionDescription: null };
      this.getObdTalkParam();
    },

    updateObdTalkMask: async function(tr) {
      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        //text: "",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      let result = null;
      result = await repository.postEntity("ResearchAndDevelopment/updateObdTalkMask", tr);
      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "Kaydetme Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      this.obdTalkParam = { startIndex: null, finishIndex: null, maskValue: null, ecuActionName: null, obdTalkMaskElementId: null, obdTalkParamId: this.obdTalkParam.obdTalkParamId, actionValue: null, actionDescription: null };
      this.getObdTalkParam();
    },

    updateObdTalkMaskElement: async function(tr) {
      // if (this.obdTalkParam.obdTalkParamId == null) {
      //   let resultConfirm = await this.$swal.fire({
      //     icon: "warning",
      //     title: "Devam etmek istediğinize emin misiniz?",
      //     text: "ObdTalkParamId girmediğiniz için. ObdTalkParam Tablosuna Yeni kayıt atılarak devam edilecektir.",
      //     showCancelButton: true,
      //     confirmButtonColor: "#3085d6",
      //     cancelButtonColor: "#d33",
      //     confirmButtonText: "Evet",
      //     cancelButtonText: "Hayır",
      //   });

      //   if (resultConfirm.isConfirmed) null;
      //   else return;
      // }

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        //text: "",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("ResearchAndDevelopment/updateObdTalkMaskElement", tr);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "Kaydetme Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      this.obdTalkParam = { startIndex: null, finishIndex: null, maskValue: null, ecuActionName: null, obdTalkMaskElementId: null, obdTalkParamId: this.obdTalkParam.obdTalkParamId, actionValue: null, actionDescription: null };
      this.getObdTalkParam();
    },

    deleteObdTalkMaskElement: async function(tr) {
      // if (this.obdTalkParam.obdTalkParamId == null) {
      //   let resultConfirm = await this.$swal.fire({
      //     icon: "warning",
      //     title: "Devam etmek istediğinize emin misiniz?",
      //     text: "ObdTalkParamId girmediğiniz için. ObdTalkParam Tablosuna Yeni kayıt atılarak devam edilecektir.",
      //     showCancelButton: true,
      //     confirmButtonColor: "#3085d6",
      //     cancelButtonColor: "#d33",
      //     confirmButtonText: "Evet",
      //     cancelButtonText: "Hayır",
      //   });

      //   if (resultConfirm.isConfirmed) null;
      //   else return;
      // }

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        //text: "",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("ResearchAndDevelopment/deleteObdTalkMaskElement", tr);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      this.obdTalkParam = { startIndex: null, finishIndex: null, maskValue: null, ecuActionName: null, obdTalkMaskElementId: null, obdTalkParamId: this.obdTalkParam.obdTalkParamId, actionValue: null, actionDescription: null };
      this.getObdTalkParam();
    },

    calculateMask: async function() {
      this.obdTalkParam.maskValue = (Math.pow(2, 1 + parseInt(this.obdTalkParam.finishIndex) - parseInt(this.obdTalkParam.startIndex)) - 1) * Math.pow(2, parseInt(this.obdTalkParam.startIndex));
    },
  },

  beforeMount() {},
  beforeUpdate() {},
  mounted() {},
  created() {},
};
</script>
